import { render, staticRenderFns } from "./holidayActFemaleMain.vue?vue&type=template&id=07b33f1c&scoped=true"
import script from "./holidayActFemaleMain.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleMain.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleMain.vue?vue&type=style&index=0&id=07b33f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b33f1c",
  null
  
)

export default component.exports